export default "__VITE_ASSET__456e65b6__"